import { render, staticRenderFns } from "./IcoBtn.vue?vue&type=template&id=1561a2e3"
import script from "./IcoBtn.vue?vue&type=script&lang=js"
export * from "./IcoBtn.vue?vue&type=script&lang=js"
import style0 from "./IcoBtn.vue?vue&type=style&index=0&id=1561a2e3&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports